import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { requestAccessToken } from "../lib/google";
import { useAuthStore } from "../lib/auth";

export default function LoginPage() {
  const navigate = useNavigate();
  const setSession = useAuthStore((s) => s.setSession);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    setError(null);
    setLoading(true);
    try {
      const { accessToken, expiresAt } = await requestAccessToken();
      setSession(accessToken, expiresAt);
      navigate("/cards");
    } catch (err) {
      setError(err instanceof Error ? err.message : "ログインに失敗しました");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="flex min-h-screen flex-col items-center justify-center bg-washi px-6 py-16">
      <div className="w-full max-w-md text-center">
        <h1 className="serif mb-3 text-3xl font-medium tracking-wide text-navy">
          つばめカード Web
        </h1>
        <p className="mb-10 text-sm leading-relaxed text-navySoft">
          名刺を、PC からも。
          <br />
          iOS 版でスキャンした名刺を Google Sheets と連携して
          <br />
          PC ブラウザから閲覧・CSV / VCF でインポート / エクスポート。
        </p>

        <button
          type="button"
          onClick={handleLogin}
          disabled={loading}
          className="btn-primary w-full"
        >
          {loading ? "Google に接続中..." : "Google でログイン"}
        </button>

        {error && (
          <p className="mt-4 text-sm text-red-600" role="alert">
            {error}
          </p>
        )}

        <p className="mt-8 text-xs leading-relaxed text-inkLight">
          ※ つばめカードが作成したスプレッドシートとフォルダにのみアクセスします。
          <br />
          ※ 当社サーバーには名刺データを一切保存しません。
        </p>

        <div className="mt-12 flex justify-center gap-6 text-xs text-inkLight">
          <a href="https://tsubamecard.com/" className="hover:underline">
            公式サイト
          </a>
          <a href="https://tsubamecard.com/privacy.html" className="hover:underline">
            プライバシーポリシー
          </a>
          <a href="https://tsubamecard.com/terms.html" className="hover:underline">
            利用規約
          </a>
        </div>
      </div>
    </main>
  );
}
